package com.fireavert.menu.client.presentation

import com.fireavert.menu.menu_navigation.client.MenuNavigator
import kotlinx.datetime.LocalDate

class MenuController(private val navigator: MenuNavigator, private val interactor: MenuInteractor) {
    fun didLoad() = interactor.didLoad()
    fun clickedDashboard() = navigator.navigate(MenuNavigator.Destination.Dashboard)
    fun clickedProperties() = navigator.navigate(MenuNavigator.Destination.Properties)
    fun clickedAdministration() = navigator.navigate(MenuNavigator.Destination.Administration)
    fun clickedReports() = navigator.navigate(MenuNavigator.Destination.Reports)
    fun clickedHelp() = navigator.navigate(MenuNavigator.Destination.Help)
    fun clickedFeedback() = navigator.navigate(MenuNavigator.Destination.Feedback)
    fun clickedMyFireRisk() = navigator.navigate(MenuNavigator.Destination.MyFireRisk)
    suspend fun updatePropertyPreferences(propertyId: Int?, pathName: String) {
        interactor.updatePropertyPreferences(propertyId, pathName)
    }

    suspend fun updatedDateRangePreferences(
        startDate: LocalDate?,
        endDate: LocalDate?,
        pathName: String,
    ) {
        interactor.updateDateRangePreferences(startDate, endDate, pathName)
    }

    suspend fun checkInitialPageState(pathName: String) {
        interactor.refreshPages(pathName)
    }

}